import { render, staticRenderFns } from "./EventInfoBar.vue?vue&type=template&id=51b3507b&"
import script from "./EventInfoBar.vue?vue&type=script&lang=js&"
export * from "./EventInfoBar.vue?vue&type=script&lang=js&"
import style0 from "./EventInfoBar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports